var React = require('react');

function PreviousEnabled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.518 14L9 12.62 2.964 7 9 1.38 7.518 0 0 7z","fillRule":"evenodd"}));
}

PreviousEnabled.defaultProps = {"width":"9","height":"14","viewBox":"0 0 9 14"};

module.exports = PreviousEnabled;

PreviousEnabled.default = PreviousEnabled;
